export type SectionDefinition = {
  id: string;
  relativeDuration: number;
  startDelay: number;
  snapPoints: number[];
  detailSections?: DetailSectionIDs[];
}

export type SectionData = SectionDefinition & {
  active: boolean;
  // this keeps track of how far we are in each section
  ratio: number;
  start: number;
  end: number;
}

export enum SectionIDs {
  Title = 'title',
  Intro1 = 'intro1',
  Intro2 = 'intro2',
  Intro3 = 'intro3',
  TellMeAJoke = 'tellMeAJoke',
  Joke = 'joke',
  Science = 'science',
  Conclusion = 'conclusion',
  Donate = 'donate',
  About = 'about',
}

export enum DetailSectionIDs {
  None = '',
  DecodingVector = 'decodingVector',
  DecodingSphere = 'decodingSphere',
  DecodingSubspaces = 'decodingSubspaces',
  DecodingTopology = 'decodingTopology',
  DecodingDynamicBehaviour = 'decodingBehavior',
}

export const IntroductionPages: SectionIDs[] = [
  SectionIDs.Intro1,
  SectionIDs.Intro2,
  SectionIDs.Intro3,
  SectionIDs.TellMeAJoke
];

export const ConclusionPages: SectionIDs[] = [
  SectionIDs.Conclusion,
  SectionIDs.About,
];


// all these are arrays for scrollvalues (fade in start, fade in end, fade out start, fade out end)
export const Sections: SectionDefinition[] = [
  {
    id: SectionIDs.Title,
    relativeDuration: 1,
    startDelay: 0,
    snapPoints: [0.4]
  },
  {
    id: SectionIDs.Intro1,
    relativeDuration: 1,
    startDelay: -0.5,
    snapPoints: [0.9]
  },
  {
    id: SectionIDs.Intro2,
    relativeDuration: 1,
    startDelay: 0,
    snapPoints: [0.7]
  },
  {
    id: SectionIDs.Intro3,
    relativeDuration: 1,
    startDelay: 0,
    snapPoints: [0.5]
  },
  {
    id: SectionIDs.TellMeAJoke,
    relativeDuration: 1,
    startDelay: 0,
    snapPoints: [0.6]
  },
  {
    id: SectionIDs.Joke,
    relativeDuration: 1,
    startDelay: 0,
    snapPoints: [0.6]
  },
  {
    id: SectionIDs.Science,
    relativeDuration: 1,
    startDelay: 0,
    snapPoints: [0.5],
    detailSections: [
      DetailSectionIDs.DecodingVector, DetailSectionIDs.DecodingSphere, DetailSectionIDs.DecodingSubspaces,
      DetailSectionIDs.DecodingTopology, DetailSectionIDs.DecodingDynamicBehaviour
    ] as DetailSectionIDs[]
  },
  {
    id: SectionIDs.Conclusion,
    relativeDuration: 1,
    startDelay: 0,
    snapPoints: [0.5]
  },
  {
    id: SectionIDs.About,
    relativeDuration: 1,
    startDelay: 0,
    snapPoints: [0.5]
  }
];